var map = {
	"./Aa.svg": 22340,
	"./add.svg": 85497,
	"./align-center-active.svg": 944,
	"./align-center.svg": 76625,
	"./align-left-active.svg": 24379,
	"./align-left.svg": 52572,
	"./align-right-active.svg": 87006,
	"./align-right.svg": 44798,
	"./asset-upload.svg": 22382,
	"./batch-editing.svg": 33850,
	"./batch-process-icon.svg": 16176,
	"./brand.svg": 58345,
	"./bring-forward-icon.svg": 15221,
	"./bring-to-front-icon.svg": 72941,
	"./camera.svg": 49868,
	"./checked.svg": 936,
	"./chevron-left-light.svg": 32906,
	"./close.svg": 47807,
	"./cloud.svg": 67236,
	"./copy-icon.svg": 46240,
	"./csv-file-icon.svg": 34414,
	"./cut.svg": 65724,
	"./delete-icon.svg": 99573,
	"./die.svg": 22257,
	"./edit.svg": 19687,
	"./feedback.svg": 23605,
	"./font-panel-bold-active.svg": 91217,
	"./font-panel-bold-deactive.svg": 86996,
	"./font-panel-italic-active.svg": 74048,
	"./font-panel-italic-deactive.svg": 78756,
	"./font-panel-underline-active.svg": 73467,
	"./font-panel-underline-deactive.svg": 17641,
	"./fw-code.svg": 27637,
	"./heart-red.svg": 14851,
	"./heart.svg": 83652,
	"./keyboard-regular.svg": 46581,
	"./left-arrow.svg": 82224,
	"./line-height-regular.svg": 81212,
	"./lock.svg": 38119,
	"./logo-new.svg": 85907,
	"./logo.svg": 37142,
	"./media.svg": 51362,
	"./menu-btn.svg": 25989,
	"./minus.svg": 20323,
	"./music-light.svg": 71329,
	"./music.svg": 54712,
	"./none-disabled.svg": 36812,
	"./none.svg": 9142,
	"./paste-icon.svg": 47410,
	"./pause.svg": 96734,
	"./play-button.svg": 81317,
	"./play.svg": 66393,
	"./plus-2.svg": 12249,
	"./plus.svg": 41602,
	"./project.svg": 47641,
	"./redo-deactive.svg": 5301,
	"./redo.svg": 67242,
	"./replace-icon.svg": 95524,
	"./right-arrow.svg": 84348,
	"./scene.svg": 88750,
	"./search.svg": 40696,
	"./send-backward-icon.svg": 23937,
	"./send-to-back-icon.svg": 37749,
	"./shuffle-solid.svg": 94053,
	"./sound-mute.svg": 75071,
	"./sound.svg": 72582,
	"./split.svg": 66790,
	"./sticker.svg": 22880,
	"./styles.svg": 46039,
	"./swap-media.svg": 11644,
	"./text.svg": 20651,
	"./transporter.svg": 64567,
	"./trash.svg": 23237,
	"./trim-icon.svg": 58399,
	"./undo-deactive.svg": 6627,
	"./undo.svg": 68913,
	"./upload.svg": 58684,
	"./view-in-grid.svg": 99848,
	"./view-in-list.svg": 96661,
	"./zoom-in.svg": 4031,
	"./zoom-out.svg": 40644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;